module.exports = __webpack_public_path__ + "img/nursing.3fb9ffa6.jpg";